import { render, staticRenderFns } from "./PreviewWord.vue?vue&type=template&id=dc142dcc&scoped=true"
import script from "./PreviewWord.vue?vue&type=script&lang=js"
export * from "./PreviewWord.vue?vue&type=script&lang=js"
import style0 from "./PreviewWord.vue?vue&type=style&index=0&id=dc142dcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc142dcc",
  null
  
)

export default component.exports